export class Limitation{
    limitation?:string;
    isDefault?: boolean;
}
export class LimitationsForNormGrades{
    gradeCustomerAnalysisLimitations?: Limitation[];
    gradeCustomerOtherLimitations?: Limitation[];
}
